import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CurrentUserService } from '../auth/current-user.service';

@Injectable({
    providedIn: 'root',
})
export class WoundHubService {
    private hubConnection: signalR.HubConnection | null = null;

    private woundStatusChangedSubject = new Subject<WoundHubModel>();
    woundStatusChanged$: Observable<WoundHubModel> =
        this.woundStatusChangedSubject.asObservable();

    private isStarted = false;

    constructor(private currentUserService: CurrentUserService) { }

    startConnection(facilityId: string | null) {
        if (this.isStarted) return;

        const session = this.currentUserService.GetSession();
        const token = session?.token;

        let url = `${environment.hubs.woundHub.url}/wound-hub`;
        if (facilityId) {
            url += `?facilityId=${facilityId}`;
        }

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(url, {
                accessTokenFactory: () => token ?? '',
            })
            .withAutomaticReconnect()
            .build();

        this.hubConnection.on('WoundStatusChanged', (payload: WoundHubModel) => {
            this.woundStatusChangedSubject.next(payload);
        });

        this.hubConnection
            .start()
            .then(() => {
                this.isStarted = true;
            })
            .catch((err) => console.error('Error while starting WoundHub:', err));
    }

    stopConnection() {
        if (this.hubConnection) {
            this.hubConnection
                .stop()
                .then(() => {
                    this.isStarted = false;
                })
                .catch((err) => console.error('Error stopping WoundHub:', err));
        }
    }
}

export interface WoundHubModel {
    id: string;
    woundStatus: number;
    imagePathOne?: string | null;
    imagePathTwo?: string | null;
    imagePathThree?: string | null;
    lidarPath?: string | null;
}